var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 4.5L16.5 12L9 19.5","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRight.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","strokeWidth":"2","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
